import apiClient from '@/services/apiClient'

/**
 * @param {{ period?: string, start_date?: string, end_date?: string }} params
 */
export async function fetchOrderAnalytics(params = {}) {
  const { data } = await apiClient.get('/orders/analytics/', { params })
  return data
}
